import type { MobileCardItem, NavigationData } from '@/core/types/cardNavigation.type'
import type { ClassData, LibraryData } from '@/core/types/library.type'
import { buildBreadcrumbs } from '@/core/utils/buildBreadcrumbs'

import { buildConstructorEntries } from './buildConstructorEntries'
import { buildFieldEntries } from './buildFieldEntries'
import { buildMethodEntries } from './buildMethodEntries'
import { EMPTY_NAVIGATION } from './emptyNavigation'

export const getClassNavigation = (
  library: LibraryData,
  libraryName: string,
  className: string,
  gateway: string,
  openAccordions: string[],
  onAccordionToggle: (itemId: string) => void,
  projectName?: string
): NavigationData => {
  const classData = library.classes?.[className] as ClassData | undefined

  if (!classData) return EMPTY_NAVIGATION

  const fieldEntries = buildFieldEntries({ classData, library, openAccordions, onAccordionToggle })
  const methodEntries = buildMethodEntries({ classData, library, openAccordions, onAccordionToggle })
  const constructorEntries = buildConstructorEntries({ classData, library, openAccordions, onAccordionToggle })

  const navigationEntries = [...methodEntries, ...fieldEntries, ...constructorEntries]
  const details = navigationEntries.map((entry) => entry.detail)
  const mobileCards: MobileCardItem[] = navigationEntries.map((entry) => entry.mobileCard)

  return {
    list: [],
    details,
    breadcrumbs: buildBreadcrumbs(
      gateway,
      libraryName,
      className,
      classData.name,
      details.length,
      projectName,
      library.name
    ),
    libraryData: library,
    classData,
    mobileCards,
  }
}
